import {
  NavClickHandleClick,
  ViewSearchResultsHandleSubmit,
} from './helpers-ga4.js';

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.isHeaderHidden = false; // Track header visibility
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyHeader = document.querySelector('sticky-header');

    if (stickyHeader.classList.contains('global-header--nav-visible')) return;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    const isScrollingDown = scrollTop > this.currentScrollTop;
    const isAboveHeader = scrollTop <= this.headerBounds.top;
    const isBelowHeader = scrollTop > this.headerBounds.bottom;

    if (isAboveHeader) {
      requestAnimationFrame(this.reset.bind(this));
      this.currentScrollTop = scrollTop;
      return;
    }

    if (isScrollingDown && isBelowHeader && !this.preventHide) {
      if (!this.isHeaderHidden) {
        requestAnimationFrame(this.hide.bind(this));
        this.isHeaderHidden = true;
      }
    } else if (
      !isScrollingDown &&
      isBelowHeader &&
      !this.preventReveal &&
      !document.querySelector('.jump-link-navigation')
    ) {
      if (this.isHeaderHidden) {
        requestAnimationFrame(this.reveal.bind(this));
        this.isHeaderHidden = false;
      }
    } else if (
      !isScrollingDown &&
      isBelowHeader &&
      !document.querySelector('.jump-link-navigation')
    ) {
      window.clearTimeout(this.isScrolling);
      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, 66);

      if (!this.isHeaderHidden) {
        requestAnimationFrame(this.hide.bind(this));
        this.isHeaderHidden = true;
      }
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
    );
    this.closeMenuDisclosure();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }
}

// main nav: keyboard accessibility

const mainNavHandleClick = (e) => {
  const visibleClass = 'global-header__mega-menu--visible';
  const el = e.target.hasAttribute('data-index')
    ? e.target
    : e.target.closest('[data-index]');
  el.classList.toggle(visibleClass);
  if (el.classList.contains(visibleClass)) {
    e.target.setAttribute('aria-expanded', 'true');
  } else {
    e.target.setAttribute('aria-expanded', 'false');
  }
};

const mainNavHandleEscKey = (e) => {
  if (e.key === 'Escape') {
    const visibleClass = 'global-header__mega-menu--visible';

    if (document.querySelector(`.${visibleClass}`)) {
      document
        .querySelector(`.${visibleClass} button`)
        .setAttribute('aria-expanded', 'false');
      document.querySelector(`.${visibleClass}`).classList.remove(visibleClass);
    }
    mobileNavCleanClasses();
  }
};

const mainNavHandleFocus = (e) => {
  const parent = e.target.closest('[data-index]');
  const parentIndex = parent.getAttribute('data-index');
  const visibleClass = 'global-header__mega-menu--visible';

  if (
    document.querySelector(
      `.global-header__mega-menu--visible:not([data-index="${parentIndex}"]).${visibleClass}`,
    )
  ) {
    document
      .querySelector(
        `.global-header__mega-menu--visible:not([data-index="${parentIndex}"]).${visibleClass}`,
      )
      .classList.remove(visibleClass);
  }
};

const mainNavCloseOnTabOut = (e) => {
  const mqList = window.matchMedia('(min-width: 1024px)');
  const navItems = document.querySelectorAll('.global-header__nav-item button');

  if (mqList.matches) {
    navItems.forEach((item) => {
      item.addEventListener('focus', mainNavHandleFocus);
    });
  } else {
    navItems.forEach((item) => {
      item.removeEventListener('focus', mainNavHandleFocus);
    });
  }
};

// main nav: mobile functionality

const mobileNavOpenHandleClick = () => {
  const stickyHeader = document.querySelector('sticky-header');

  stickyHeader.classList.toggle('global-header--nav-visible');
  document.querySelector('body').classList.toggle('overflow-hidden-tablet');
};

const mobileNavShowChildrenHandleClick = (e) => {
  const menuShow = document.querySelectorAll('.global-header__mega-menu--show');
  menuShow.forEach((menu) => {
    menu.classList.remove('global-header__mega-menu--show');
  });

  const parentEl = e.target.parentElement;
  const index = parentEl.getAttribute('data-index');
  parentEl.classList.toggle('global-header__mega-menu--show');
};

const mobileNavCleanClasses = () => {
  const navItems = document.querySelectorAll('.global-header__nav-item');
  const stickyHeader = document.querySelector('sticky-header');

  stickyHeader.classList.remove('global-header--nav-visible');
  document.querySelector('body').classList.remove('overflow-hidden-tablet');
  navItems.forEach((link) => {
    link.classList.remove('global-header__nav-item--hide');
    link.classList.remove('global-header__mega-menu--show');
  });
};

const mobileChildItemsHandleClick = (e) => {
  e.preventDefault();
  mobileNavCleanClasses();
  const target = e.target.target === '' ? '_self' : `${e.target.target}`;
  window.open(e.target.href, target);
};

const mobileMenu = () => {
  const mqList = window.matchMedia('(max-width: 1023px)');
  const button = document.getElementById('globalHeaderMobileButton');
  const parentItems = document.querySelectorAll(
    '.global-header__nav-item--has-children',
  );
  const childItems = document.querySelectorAll('.global-header__mega-menu a');

  if (mqList.matches) {
    const announcement = document.querySelector('.announcement-bar__message');
    const navRow = document.querySelector('.global-header__nav-row');
    const navItems = document.querySelector('.global-header__nav-items');
    navItems.style.top = announcement.offsetHeight + navRow.offsetHeight - 2 + 'px';

    button.addEventListener('click', mobileNavOpenHandleClick);
    parentItems.forEach((parent) => {
      parent.addEventListener('click', mobileNavShowChildrenHandleClick, true);
    });
    childItems.forEach((child) => {
      child.addEventListener('click', mobileChildItemsHandleClick);
    });
  } else {
    button.removeEventListener('click', mobileNavOpenHandleClick);
    parentItems.forEach((parent) => {
      parent.removeEventListener(
        'click',
        mobileNavShowChildrenHandleClick,
        true,
      );
    });
    childItems.forEach((child) => {
      child.removeEventListener('click', mobileChildItemsHandleClick);
    });
    mobileNavCleanClasses();
  }
};

// main nav: desktop hover functionality

const mainNavHandleMouseOver = (e) => {
  const el = e.target.hasAttribute('data-index')
    ? e.target
    : e.target.closest('[data-index]');
  el.classList.add('global-header__mega-menu--visible');
};

const mainNavHandleMouseOut = (e) => {
  const el = e.target.hasAttribute('data-index')
    ? e.target
    : e.target.closest('[data-index]');
  el.classList.remove('global-header__mega-menu--visible');
};

const mainNavItemHover = () => {
  const mqList = window.matchMedia('(min-width: 1024px)');
  const parentLink = document.querySelectorAll(
    '.global-header__nav-item--has-children',
  );

  document.addEventListener('keyup', mainNavHandleEscKey);
  if (mqList.matches) {
    parentLink.forEach((link, i) => {
      link.addEventListener('mouseover', mainNavHandleMouseOver);
      link.addEventListener('mouseout', mainNavHandleMouseOut);
    });
    parentLink.forEach((link, i) => {
      link.addEventListener('click', mainNavHandleClick);
    });
  } else {
    parentLink.forEach((link, i) => {
      link.removeEventListener('mouseover', mainNavHandleMouseOver);
      link.removeEventListener('mouseout', mainNavHandleMouseOut);
    });
    parentLink.forEach((link, i) => {
      link.removeEventListener('click', mainNavHandleClick);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('sticky-header', StickyHeader);
  mobileMenu();
  mainNavItemHover();
  mainNavCloseOnTabOut();

  const navClickLinks = `.global-header [data-ga4-event-type*="nav_click"]`;
  const searchForm = `siteSearch`;
  document.querySelectorAll(navClickLinks).forEach((link) => {
    link.addEventListener('click', NavClickHandleClick);
  });

  // document.getElementById(searchForm).addEventListener('submit', ViewSearchResultsHandleSubmit);
});

window.addEventListener('resize', (e) => {
  mobileMenu();
  mainNavItemHover();
  mainNavCloseOnTabOut();
});
